<template>
  <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
    <b-overlay :show="loadingAndamento">
      <b-modal
        v-model="modalAberto"
        :title="titulo"
        size="lg"
        header-bg-variant="secondary"
        header-text-variant="light"
        @hide="closeModal"
        centered
      >
        <b-form @submit.prevent="handleSubmit(adicionarAndamento)">
          <b-container>
            <b-row>
              <b-col cols="12">
                <default-form-validation-provider
                  label="Tipo"
                  v-slot="defaultState"
                >
                  <b-form-select
                    id="select-tipo"
                    :state="defaultState.state"
                    :options="listaTipo"
                    v-model="tipo"
                  />
                </default-form-validation-provider>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <default-form-validation-provider
                  label="Descrição"
                  v-slot="defaultState"
                >
                  <b-form-textarea
                    id="input-descricao"
                    :state="defaultState.state"
                    v-model="descricao"
                    placeholder="Digite a descrição do andamento"
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                </default-form-validation-provider>
              </b-col>
            </b-row>
          </b-container>
        </b-form>
        <template #modal-footer>
          <b-button size="sm" variant="outline-secondary" @click="closeModal"
            >Cancelar</b-button
          >
          <b-button
            size="sm"
            variant="secondary"
            type="submit"
            @click="adicionarAndamento"
          >
            Adicionar Andamento
          </b-button>
        </template>
      </b-modal>
    </b-overlay>
  </validation-observer>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { ValidationObserver } from "vee-validate";
import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import ouvidoriaService from "@/services/administracao/ouvidoriaService";
import { SelectValue } from "@/types/select-value";

@Component({
  components: {
    ValidationObserver,
    DefaultFormValidationProvider,
  },
})
export default class ModalAdicionarAndamento extends mixins(UtilsTS, Vue) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;
  @Prop({ required: true }) titulo!: string;
  @Prop({ required: true }) idManifestacao: number;

  loadingAndamento = false;
  modalAberto = true;
  descricao = "";
  listaTipo: SelectValue[] = [];
  tipo = "";

  async created() {
    await this.getListaTipo();
  }

  async getListaTipo() {
    try {
      this.loadingAndamento = true;
      const response = await ouvidoriaService.getAllStatus();
      this.listaTipo = response.map((item: any) => {
        return { value: item.Status, text: this.capitalize(item.Status) };
      });
      this.listaTipo.unshift({
        value: "",
        text: "Selecione o tipo de andamento",
      });
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.loadingAndamento = false;
    }
  }

  async adicionarAndamento() {
    try {
      this.loadingAndamento = true;
      const isValid = await this.validationobserver.validate();
      if (!isValid) {
        console.error(this.validationobserver);
        return;
      }

      await ouvidoriaService.adicionarAndamento(
        this.idManifestacao,
        this.tipo,
        this.descricao
      );
      this.$toast.success("Andamento adicionado com sucesso!");
      this.reload();
      this.closeModal();
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.loadingAndamento = false;
    }
  }

  closeModal() {
    this.$emit("close");
  }

  reload() {
    this.$emit("reload");
  }
}
</script>
